import { z } from "zod";

const ClinicPartnersMemberSchema = z.object({
  id: z.number(),
  name: z.string(),
  us_provider_group_clinics: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
    })
  ),
});

export const GetClinicPartnersMembersResponseSchema = z.object({
  items: z.array(ClinicPartnersMemberSchema),
});
